<template functional>
    <div class="bto-sb-widget-live-now-market">
        <div class="bto-sb-event-odds-cell">{{props.t(props.market.n)}}</div>
        <div class="bto-sb-event-odds-cell">
            <span class="bto-sb-event-marketlabel"
                  v-if="props.market.sbv">{{props.isThreeWay ? props.t('Match.Goals') : props.t('Public.Points')}}</span>
            <span class="bto-sb-event-marketlabel"
                  v-for="(o, i) in props.market.on"
                  :key="`${props.market.id}-${o.n}${i}`">
                {{props.t(o.n)}}
            </span>
        </div>
    </div>
</template>

<script>
  export default {
    // eslint-disable-next-line
    name: "Market",
    props: {
      t: {
        type: Function,
        default: (n) => n
      },
      market: {
        type: Object,
        default: () => {
        }
      },
      isThreeWay: {
        type: Boolean,
        required: true
      },
    }
  };
</script>
